module.exports = "{{ alias ? '(' +  alias + ')' : '' }} ";